export default __webpack_public_path__ + "static/media/ic_cloud.dee767dd.svg";